// extracted by mini-css-extract-plugin
export var container = "_te-0";
export var table = "_te-2";
export var tableWrapper = "_te-1";